//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment'
export default {
  props: ['ruleForm', 'print'],
  data() {
    return  {
      dataUrl: ''
    }
  },
  beforeMount () {
  },
  methods: {
    getDate (createdAt) {
      if (!createdAt) {
        return ''
      }
      return moment(createdAt).format('YYYY年MM月DD日')
    },
    html2Image () {
      var target = document.getElementById(this.ruleForm._id)
      var printWindow=window.open("","打印窗口","_blank");
      printWindow.document.write(`
      <html>
      <meta charset="utf-8">
      <meta http-equiv="X-UA-Compatible" content="IE=edge">
      <meta name="viewport" content="width=device-width,initial-scale=1.0">
      <head>
        <style>
          .underline {
            text-decoration:underline
          }
          p {
            line-height: 22px;
          }
          table td
          {
            width: 200px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            border: 1px solid black;
          }
        </style>
      </head>${target.innerHTML}</html>`
      )
      printWindow.document.close();
      printWindow.print();
    }
  }
}
